import { ReduxLogsType, ReduxLoggingState } from './redux-logging-reducer'
import {
  ADD_REDUX_LOG,
  SET_REDUX_LOG_DATA,
  SEND_REDUX_LOGS_TO_ROLLBAR,
  RESET_REDUX_LOG_DATA,
  RESET_ALL_REDUX_LOG_DATA,
  AddReduxLog,
  SetReduxLogData,
  SendReduxLogsToRollbar,
  ResetAllReduxLogData,
  ResetReduxLogData,
} from './redux-logging-action-types'
import { ReduxLoggingTypeEnum } from './redux-logging-reducer'

export const addReduxLog = ({
  newLog,
}: {
  newLog: ReduxLogsType[0]
}): AddReduxLog => ({
  type: ADD_REDUX_LOG,
  payload: newLog,
})

export const setReduxLogData = <
  ReduxLoggingType extends ReduxLoggingTypeEnum,
>(payload: {
  logType: ReduxLoggingType
  data: NonNullable<ReduxLoggingState['logData'][ReduxLoggingType]>[0]
}): SetReduxLogData<ReduxLoggingType> => ({
  type: SET_REDUX_LOG_DATA,
  payload,
})

export const sendReduxLogsToRollbar = <
  ReduxLoggingType extends ReduxLoggingTypeEnum,
>(payload: {
  logType: ReduxLoggingType
  data: NonNullable<ReduxLoggingState['logData'][ReduxLoggingType]>[0]
}): SendReduxLogsToRollbar<ReduxLoggingType> => ({
  type: SEND_REDUX_LOGS_TO_ROLLBAR,
  payload,
})

export const resetReduxLogData = <
  ReduxLoggingType extends ReduxLoggingTypeEnum,
>(payload: {
  logType: ReduxLoggingType
  data: NonNullable<ReduxLoggingState['logData'][ReduxLoggingType]>[0]
}): ResetReduxLogData<ReduxLoggingType> => ({
  type: RESET_REDUX_LOG_DATA,
  payload,
})

export const resetAllReduxLogData = (payload: {
  logType: ReduxLoggingTypeEnum
}): ResetAllReduxLogData => ({
  type: RESET_ALL_REDUX_LOG_DATA,
  payload,
})
